import React, { useState, useEffect } from "react";
import { LanguageContext } from "./LanguageContext";
import { translations } from "../api/translations";

export const LanguageProvider = ({ children }) => {
  const browserDefault = navigator.language.startsWith("fr")
    ? "fr"
    : navigator.language.startsWith("de")
    ? "de"
    : navigator.language.startsWith("es")
    ? "es"
    : "en";
  let stored = null;
  try {
    stored = localStorage.getItem("lang");
  } catch {}
  const initial = stored || browserDefault;
  const [language, setLanguageState] = useState(initial);

  const setLanguage = (newLanguage) => {
    const available = Object.keys(translations || {});
    const next = available.includes(newLanguage) ? newLanguage : available[0] || "en";
    setLanguageState(next);
  };

  useEffect(() => { try { localStorage.setItem("lang", language); } catch {} }, [language]); // Cette dépendance assure que le code s'exécute chaque fois que `language` change.

  const translate = (key) => {
    const pack = translations?.[language];
    if (pack && key in pack) return pack[key];
    const fallback = translations?.en;
    return (fallback && key in fallback) ? fallback[key] : key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, translate }}>
      {children}
    </LanguageContext.Provider>
  );
};
